import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: left;
`;

export const Small = styled.p`
  margin: 0;
  font-size: 10px;
  line-height: 15px;
  color: var(--text-light);
`;
